import { render, staticRenderFns } from "./PostCommentView.vue?vue&type=template&id=7f996971&scoped=true&"
import script from "./PostCommentView.vue?vue&type=script&lang=js&"
export * from "./PostCommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f996971",
  null
  
)

export default component.exports